const updatesData = [
  {
    time: '07-31',
    tag: '上新',
    tagColor: 'bg-accent-500',
    title: '《长相思 第二季》大结局已更新，会员抢先看全集',
    desc: '相柳与小夭的命运牵动千万观众的心，结局催泪程度超乎想象，速来解锁最终章。',
  },
  {
    time: '07-31',
    tag: '热门',
    tagColor: 'bg-primary-500',
    title: '《你比星光美丽》播放量突破50亿',
    desc: '谭松韵与许凯的甜蜜搭档持续霸屏，都市爱情新标杆，全网热议不断。',
  },
  {
    time: '07-30',
    tag: '推荐',
    tagColor: 'bg-secondary-500',
    title: '暑期档韩剧《好搭档》收视率再创新高',
    desc: '张娜拉回归之作口碑爆棚，韩国本土收视率突破15%，成为今夏最受关注韩剧。',
  },
  {
    time: '07-29',
    tag: '上新',
    tagColor: 'bg-accent-500',
    title: '《玫瑰的故事》全40集已同步上线',
    desc: '刘亦菲领衔主演的都市情感大剧，讲述女性成长与自我觉醒的动人故事。',
  },
  {
    time: '07-28',
    tag: '公告',
    tagColor: 'bg-primary-500',
    title: '香蕉影视CDN节点全面升级完成',
    desc: '新增12个国内加速节点，看剧加载速度提升40%，偏远地区用户体验大幅改善。',
  },
  {
    time: '07-27',
    tag: '热门',
    tagColor: 'bg-secondary-500',
    title: '《庆余年 第二季》豆瓣评分8.5持续走高',
    desc: '张若昀再度封神，权谋与喜剧完美融合，第二季口碑超越第一季。',
  },
  {
    time: '07-26',
    tag: '上新',
    tagColor: 'bg-accent-500',
    title: '《狐妖小红娘月红篇》番外篇独家上线',
    desc: '国漫改编真人剧番外内容不容错过，杨幂与龚俊再度演绎经典角色。',
  },
  {
    time: '07-25',
    tag: '活动',
    tagColor: 'bg-primary-500',
    title: '「暑期追剧季」活动火热进行中',
    desc: '参与追剧打卡赢取限定周边好礼，每日签到还可解锁专属剧集推荐。',
  },
  {
    time: '07-24',
    tag: '推荐',
    tagColor: 'bg-secondary-500',
    title: '小众高分日剧《重启人生》引发现象级讨论',
    desc: '穿越题材的温情治愈之作，豆瓣9.4分封神，被网友称为「年度最佳日剧」。',
  },
];

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">追剧快讯</h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">最新剧集上线、平台动态、活动公告，香蕉影视第一手资讯尽在这里</p>
        </div>

        <div className="relative pl-8 border-l-2 border-background-200 space-y-8">
          {updatesData.map((item, i) => (
            <div key={i} className="relative group cursor-pointer">
              <div className="absolute -left-[2.15rem] top-1 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50"></div>
              <div className="flex flex-col sm:flex-row sm:items-center gap-2 mb-2">
                <span className="text-xs text-foreground-400 font-mono">{item.time}</span>
                <span className={`inline-flex px-2 py-0.5 rounded-full text-white text-xs font-medium w-fit whitespace-nowrap ${item.tagColor}`}>{item.tag}</span>
              </div>
              <h3 className="font-medium text-foreground-900 text-sm mb-1 group-hover:text-primary-500 transition-colors">{item.title}</h3>
              <p className="text-foreground-500 text-xs leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}